{
  "version": 1,
  "asset_id": "b706b37f-9fb6-4f15-8352-d3fa1c3d9d19",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/b706b37f-9fb6-4f15-8352-d3fa1c3d9d19/lecanto-black-shingle-roof-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/b706b37f-9fb6-4f15-8352-d3fa1c3d9d19/lecanto-black-shingle-roof-768w.avif",
  "original_filename": "lecanto-black-shingle-roof-768w.avif",
  "size": 71704,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
